import React, { useEffect, useState } from "react";
import { View, Grid, Flex, Card, Placeholder, useTheme, } from "@aws-amplify/ui-react";

import MiniStatistics from "./MiniStatistics";
import TrafficSources from "./TrafficSources";

import "./Usage.css";
import TitleSection from "../../components/titlesection/TitleSection";

/// Mock Data
const barChartDataDemo = [
  {
    name: "Web",
    data: [
      11, 8, 9, 10, 3, 11, 11, 11, 12, 13, 2, 12, 5, 8, 22, 6, 8, 6, 4, 1, 8,
      24, 29, 51, 40, 47, 23, 26, 50, 26, 22, 27, 46, 47, 81, 46, 40,
    ],
  },
  {
    name: "Social",
    data: [
      7, 5, 4, 3, 3, 11, 4, 7, 5, 12, 12, 15, 13, 12, 6, 7, 7, 1, 5, 5, 2, 12,
      4, 6, 18, 3, 5, 2, 13, 15, 20, 47, 18, 15, 11, 10, 9,
    ],
  },
  {
    name: "Other",
    data: [
      4, 9, 11, 7, 8, 3, 6, 5, 5, 4, 6, 4, 11, 10, 3, 6, 7, 5, 2, 8, 4, 9, 9, 2,
      6, 7, 5, 1, 8, 3, 12, 3, 4, 9, 7, 11, 10,
    ],
  },
];


const getChartData = () =>
  new Promise((resolve, reject) => {
    if (!barChartDataDemo) {
      return setTimeout(() => reject(new Error("no data")), 750);
    }

    setTimeout(() => resolve(Object.values(barChartDataDemo)), 750);
  });

const Usage = () => {
  const [barChartData, setBarChartData] = useState<any | null>(null);
  const [trafficSourceData, setTrafficSourceData] = useState<any | null>(null);
  const { tokens } = useTheme();

  useEffect(() => {
    const doChartData = async () => {
      const result = await getChartData();
      setBarChartData(result);
      setTrafficSourceData([150, 120, 230]);
    };

    doChartData();
  }, []);

  return (
    <>
      <TitleSection title="Usage" />
      <View borderRadius="6px" maxWidth="100%" padding="0rem" minHeight="100vh">
        <Grid
          templateColumns={{ base: "1fr", large: "1fr 1fr 1fr" }}
          templateRows={{ base: "repeat(4, auto)", large: "repeat(3, auto)" }}
          gap={tokens.space.xl}
        >
          <View rowSpan={{ base: 1, large: 1 }}>
            <MiniStatistics
              title="API Calls"
              amount="100"
              percentage={"18"}
              progress={"20"}
              bgcolor={"#e2ffed"}
              textcolor={"#008425"}
            />
          </View>
          <View rowSpan={{ base: 1, large: 1 }}>
            <MiniStatistics
              title="Productivity Improvement"
              amount="10%"
              progress={"2"}
              bgcolor={"#fef0f9"}
              textcolor={"#ff5757"}
            />
          </View>
          <View rowSpan={{ base: 1, large: 1 }}>
            <MiniStatistics
              title="Tokens used"
              amount="500"
              percentage={"18"}
              progress={"40"}
              bgcolor={"#eef6ff"}
              textcolor={"#029bf4"}
            />
          </View>

          <View columnSpan={[1, 1, 2]} rowSpan={{ base: 3, large: 4 }}>
            <Grid>
              <Card className="Productivity">
                <div className="card-title">Productivity</div>
                <div className="productivity-container">
                  <div className="time">
                    <span className="hour">
                      <h2>500h</h2>
                      <span>Hours saved</span>
                    </span>
                    <span className="days">20.8 days</span>
                  </div>
                  <span>
                    +2% this week
                  </span>
                </div>
                <div className="chart-wrap">
                  {barChartData ? (
                    <TrafficSources
                      title="Traffic Sources"
                      data={trafficSourceData}
                      type="donut"
                      labels={[
                        "Documentation",
                        "Finance",
                        "Automation",
                      ]}
                    />
                  ) : (
                    <Flex direction="column" minHeight="285px">
                      <Placeholder size="small" />
                      <Placeholder size="small" />
                      <Placeholder size="small" />
                      <Placeholder size="small" />
                    </Flex>
                  )}
                </div>
              </Card>
            </Grid>
          </View>
          <View rowSpan={{ base: 1, large: 4 }}>
          <Card className="topperformers">
          <h3 className="mb-4">Top Performers</h3>
          <table>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/1.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Alfredo</span></td>
                  <td><span className="hours">20h</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                      <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/2.png"}></img>
                    </div>
                  </td>
                  <td>
                    <span className="name">
                      Claudia
                    </span>
                  </td>
                  <td><span className="hours">14h</span></td>

                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/3.png"}></img>
                    </div>
                  </td>
                  <td>
                    <span className="name">Cahaya</span>
                  </td>
                  <td><span className="hours">11h</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/4.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Mariana</span></td>
                  <td><span className="hours">7h</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/5.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Olivia</span></td>
                  <td><span className="hours">5h</span></td>
                </tr>
              </table>
          </Card>
          </View>


        </Grid>
      </View>
    </>
  );
};

export default Usage;
